module.exports = __webpack_public_path__ + "static/media/step-challenge-enrol-period.65e09d4b.png";